import React from 'react'
import styles from "./MyProfileShimmer.module.scss";

const MyProfileShimmer = () => {
    return (
        <div className={styles.profile_shimmer}>
            <div className={styles.shimmer_box}>
                <div className={styles.shimmer_header}>
                    <div>
                        <span className={`${styles.title} shimmer`} />
                        <span className={`${styles.sub_title} shimmer`} />
                    </div>
                    <span className={`${styles.action_btn} shimmer`} />
                </div>
                <div className={styles.profile_info}>
                    <span className={`${styles.profile_img} shimmer`} />
                    <div>
                        <span className={`${styles.profile_info_text} shimmer`} />
                        <span className={`${styles.profile_info_text} shimmer`} />
                        <span className={`${styles.profile_info_text} shimmer`} />
                        <span className={`${styles.profile_info_text} shimmer`} />
                    </div>
                    <div className='d-md-block d-none'>
                        <span className={`${styles.profile_info_text} shimmer`} />
                        <span className={`${styles.profile_info_text} shimmer`} />
                        <span className={`${styles.profile_info_text} shimmer`} />
                        <span className={`${styles.profile_info_text} shimmer`} />
                    </div>
                    <div className="d-lg-block d-none">
                        <span className={`${styles.profile_info_text} shimmer`} />
                        <span className={`${styles.profile_info_text} shimmer`} />
                        <span className={`${styles.profile_info_text} shimmer`} />
                        <span className={`${styles.profile_info_text} shimmer`} />
                    </div>
                </div>
            </div>
            <div className={styles.shimmer_box}>
                <div className={styles.shimmer_header}>
                    <div>
                        <span className={`${styles.title} shimmer`} />
                        <span className={`${styles.sub_title} shimmer`} />
                    </div>
                    <span className={`${styles.action_btn} shimmer`} />
                </div>
                <div className={styles.payment_methods}>
                    <div className={`${styles.payment_box}`}>
                        <span className={`${styles.payment_box_icon} shimmer`} />
                        <span className={`${styles.payment_box_title} shimmer`} />
                        <span className={`${styles.payment_box_text} shimmer`} />
                        <span className={`${styles.payment_box_title} shimmer`} />
                    </div>
                    <div className={`${styles.payment_box} d-sm-block d-none`}>
                        <span className={`${styles.payment_box_icon} shimmer`} />
                        <span className={`${styles.payment_box_title} shimmer`} />
                        <span className={`${styles.payment_box_text} shimmer`} />
                        <span className={`${styles.payment_box_title} shimmer`} />
                    </div>
                    <div className={`${styles.payment_box} d-md-block d-none`}>
                        <span className={`${styles.payment_box_icon} shimmer`} />
                        <span className={`${styles.payment_box_title} shimmer`} />
                        <span className={`${styles.payment_box_text} shimmer`} />
                        <span className={`${styles.payment_box_title} shimmer`} />
                    </div>
                </div>
            </div>
            <div className={styles.shimmer_box}>
                <div className={styles.shimmer_header}>
                    <div>
                        <span className={`${styles.title} shimmer`} />
                        <span className={`${styles.sub_title} shimmer`} />
                    </div>
                    <span className={`${styles.action_btn} shimmer`} />
                </div>
            </div>
        </div>
    )
}

export default MyProfileShimmer
